import { makeStyles } from '@material-ui/core/styles';
const useStyles = makeStyles((theme) => ({
    sectionTitle: {
        fontSize: `16px`
    },
    root: { 
        paddingTop: 10 
    }
}));
export default useStyles;